import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import RequestFilter from "../components/requests/RequestFilter";
import RequestTable from "../components/requests/RequestTable";
import { Button, FontIcon } from "react-md";

import { getRequestWithFilter, setFilter } from "../actions/requestActions";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween, TouchTableHeader} from "../AtollonTheme/ReactElements";
import Translation from "../Atollon/Translation";
import {getTitleSuffixForRequestFilterStructure} from "../Atollon/Requests";

const Requests = ( parameters ) =>
{
  let { history, requestsOther, filter } = parameters;
  let titleSuffix = getTitleSuffixForRequestFilterStructure( filter );

  return (
    <div className="flex-col">
        <TouchPageHeader
            title={`Čeká na ostatní ${titleSuffix}`}
            buttons={(
                <div>
                    <Button
                        raised
                        className="btn btn-primary touchButton-1"
                        label={Translation( 'request-new', "Nový požadavek" )}
                        onClick={() => history.push( "/request-new" )}
                    >
                        <FontIcon className="color-white">album</FontIcon>
                    </Button>

                    <Button
                        raised
                        className="btn btn-primary touchButton-5"
                        label={Translation( 'request-received', "Zadat přijatý požadavek" )}
                        style={{ color: 'inherit' }}
                        onClick={() => history.push( "/request-received" )}
                    >
                        <FontIcon className="color-white">album</FontIcon>
                    </Button>
                </div>
            )}
        />
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>
      {/*
      <RequestFilter
        history={history}
      />
      */}

        <TouchTableHeader
            title={"Čeká na ostatní"}
            titleNumber={requestsOther ? requestsOther.count : 0}
            titleButtons={null}
        />

      <RequestTable
        history={history}
        requests={requestsOther}
        filter={filter}
      />
    </div>
  );
};

export default compose(
  connect(
    ({ request: { requestsOther, filter } }) => ({
      requestsOther,
      filter
    }),
    { getRequestWithFilter, setFilter }
  ),
  lifecycle({
    async componentWillMount() {
      const { getRequestWithFilter, setFilter } = this.props;

      setFilter(true, true, true, false, false, false, "", 10, "CREATED", "ANY");

      getRequestWithFilter("NOT_PENDING");
    }
  })
)(Requests);



// WEBPACK FOOTER //
// ./src/pages/RequestsOther.js